import { Model, RailsFormat } from "./model";

export class Template extends Model {

  constructor(
    public id?: number,
    public description: string = null,
    public subject: string = null,
    public body: string = null,
    public labels: string[] = [],
    public typeOf: number = 0,
    public slug: string = null,
  ) {
    super()
  }

  public static clone(obj: any) {
    const result = new this()

    if (obj.id) { result.id = obj.id }
    if (obj.description) { result.description = obj.description }
    if (obj.subject) { result.subject = obj.subject }
    if (obj.body) { result.body = obj.body }
    if (obj.labels) { result.labels = JSON.parse(obj.labels) }
    if (obj.typeOf != undefined) { result.typeOf = obj.typeOf }
    if (obj.slug) { result.slug = obj.slug }

    return result
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/models/template.ts